import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Catch any unhandled errors and show them on screen
// (helpful for debugging on iPhone where we can't open dev tools)
window.onerror = function(msg, src, line, col, error) {
  document.body.innerHTML = `
    <div style="padding:20px;font-family:monospace;font-size:12px;color:red;background:white;word-break:break-all">
      <h3>Error</h3>
      <p><b>Message:</b> ${msg}</p>
      <p><b>Source:</b> ${src}</p>
      <p><b>Line:</b> ${line}</p>
      <p><b>Stack:</b> ${error?.stack || 'none'}</p>
    </div>`;
  return false;
};

window.addEventListener('unhandledrejection', function(event) {
  document.body.innerHTML = `
    <div style="padding:20px;font-family:monospace;font-size:12px;color:red;background:white;word-break:break-all">
      <h3>Unhandled Promise Rejection</h3>
      <p>${event.reason?.message || event.reason}</p>
      <p><b>Stack:</b> ${event.reason?.stack || 'none'}</p>
    </div>`;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);